export const globalData = {
	email: 'info@netspace.am',
	googleSearchLink: 'https://www.google.com/search?q=Net+Space&oq=Net+Space&gs_lcrp=EgZjaHJvbWUyBggAEEUYOTIGCAEQRRg8MgYIAhBFGDwyBggDEEUYPNIBCDczOTNqMGoxqAIAsAIA&sourceid=chrome&ie=UTF-8&sei=VUW6Z_PvC6eExc8Ph_3FoAM',
	phone: [
		{
			name: '(+374) 44 77 50 77',
			value: '+37444775077',
		},
		{
			name: '(+374) 44 75 00 42',
			value: '+37444750042',
		},
	],
	socials: {
		facebook: 'https://www.facebook.com/profile.php?id=61558443554013',
		instagram: 'https://www.instagram.com/net__space/',
	},

	en: {
		director: 'Vigen Nalbandyan',
		address: 'Yerevan, Armenia',
		openingHours: '24/7 service schedule',
	},

	hy: {
		director: 'Վիգեն Նալբանդյան',
		address: 'Երևան, Հայաստան',
		openingHours: '24/7 աշխատանքային գրաֆիկով սպասարկում',
	},
};
